<template lang="html">
  <div class="slide">
    <svg ref="scene" class="canvas" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <clipPath id="clipFrame">
        <rect x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      </clipPath>
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <g clip-path="url(#clipFrame)">
        <g ref="bg">
          <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
            <picture>
              <source :srcset="`${publicPath}scenes/bucket/Bucket1-480w.jpg`" media="(max-width: 480px)">
              <source :srcset="`${publicPath}scenes/bucket/Bucket1-768w.jpg`" media="(max-width: 768px)">
              <source :srcset="`${publicPath}scenes/bucket/Bucket1-1280w.jpg`" media="(max-width: 1280px)">
              <source :srcset="`${publicPath}scenes/bucket/Bucket1-1920w.jpg`" media="(max-width: 1920px)">
              <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/bucket/Bucket1.jpg`" />
            </picture>
          </foreignObject>
        </g>
        <g ref="bucket">
          <g transform="translate(1003 0)">
            <ImageLazy
            width="2014" height="3006"
            :srcs="[
            `${publicPath}scenes/bucket/Bucket2-q80-w400.png`,
            `${publicPath}scenes/bucket/Bucket2.png`
            ]"/>
          </g>
          <g class="ripples">
            <image width="1381" height="269" x="1302" y="1559" :xlink:href="`${publicPath}scenes/bucket/Bucket3.png`"/>
            <image width="1306" height="299" x="1320" y="1533" :xlink:href="`${publicPath}scenes/bucket/Bucket4.png`"/>
            <image width="1279" height="302" x="1336" y="1533" :xlink:href="`${publicPath}scenes/bucket/Bucket5.png`"/>
          </g>
        </g>
      </g>
    </svg>
    <SceneDialogue
      ref="d1"
      :width=".3"
      :tx="0" :ty="0.25">
      He kept a squash field in the winters, just above the canyon. You could
      always see him scooping from the river below with old coffee cans, and
      trekking back up with them to the fields.
    </SceneDialogue>
    <SceneDialogue
      ref="d2"
      :width=".25"
      :tx="1" :ty="0.75">
      You should have seen those squash blossoms come alive in the late
      summer.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/bucket/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import SceneDialogue from "../SceneDialogue.vue"
import Template from "./Template.vue"
import { TimelineLite, TweenLite } from "gsap"

export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    canvasWidth: 4175,
    canvasHeight: 3006,
  }),
  props: ["slide"],
  extends: Template,
  mounted() {
    const d1 = this.$refs["d1"].$el
    const d2 = this.$refs["d2"].$el
    const { bg, bucket } = this.$refs

    TweenLite.set(d1, {opacity: 0})
    TweenLite.set(d2, {opacity: 0})
    TweenLite.set(bg, {opacity: 0, scale: 1.2, transformOrigin: "center center"})
    TweenLite.set(bucket, {opacity: 0, scale: 1.2, y: -300, transformOrigin: "center center"})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(bg, 3, {opacity: 1, scale: 1, transformOrigin: "center center"}))
    this.tl.add(TweenLite.to(bucket, 1, {opacity: 1, scale: 1, y: 0, transformOrigin: "center center"}), "-=1")
    this.tl.add(TweenLite.to(d1, 1, {opacity: 1}), "+=0.5")
    this.tl.add(TweenLite.to(d2, 1, {opacity: 1}), "-=0.5")
  },
  methods: {
    enter() { this.tl.play() }
  },
  components: {
    SceneDialogue,
  },
}
</script>

<style lang="scss" scoped>
.ripples {
  image {
    animation: ripple 1s infinite;
    animation-timing-function: steps(0, end);
    &:nth-of-type(1) { animation-delay: 0s; }
    &:nth-of-type(2) { animation-delay: -.25s; }
    &:nth-of-type(3) { animation-delay: -.5s; }
  }
}
@keyframes ripple {
  0% { opacity: 1 }
  33% { opacity: 0 }
}
</style>
